import { createAsyncAction } from '../../utils/asyncHelpers';
import * as actionTypes from '../../constants/actionTypes/accountActionTypes';
import {
  accountReportSearchFetch,
  accountGroupedCertificatesFetch,
  accountCancelGroupedCertificatesFetch,
  accountEecsOverviewSearchFetch,
  accountEecsTotalFetch,
  accountAllEecsFetch,
} from '../actionHelpers/endpoints';

export const fetchAccountOverview = createAsyncAction(
  actionTypes.ACCOUNT_OVERVIEW_SEARCH_FETCH,
  accountGroupedCertificatesFetch
);

export const fetchGroupedCertificates = createAsyncAction(
  actionTypes.ACCOUNT_GROUPED_CERTIFICATES_FETCH,
  accountGroupedCertificatesFetch
);

export const fetchEecsAccountOverview = createAsyncAction(
  actionTypes.ACCOUNT_EECS_OVERVIEW_SEARCH_FETCH,
  accountEecsOverviewSearchFetch
);

export const fetchAllEecsGOsForAccount = createAsyncAction(
  actionTypes.ACCOUNT_ALL_EECS_FETCH,
  accountAllEecsFetch
);

export const fetchEecsAccountTotal = createAsyncAction(
  actionTypes.ACCOUNT_EECS_TOTAL_FETCH,
  accountEecsTotalFetch
);

export const fetchCancelGroupedCertificates = createAsyncAction(
  actionTypes.ACCOUNT_CANCEL_GROUPED_CERTIFICATES_FETCH,
  accountCancelGroupedCertificatesFetch
);

export const fetchAccountReport = createAsyncAction(
  actionTypes.ACCOUNT_REPORT_SEARCH_FETCH,
  accountReportSearchFetch
);

export const setEecsGoRows = (rows) => ({
  type: actionTypes.SET_EECS_GO_ROWS,
  payload: rows,
});
